export const hasRole = (roles, searchRole) =>
  Array.isArray(roles) && roles.some((role) => role.endsWith(`:${searchRole}`));
